import React, { PropsWithChildren } from 'react';
import ObjectLink from 'components/ui/ObjectLink';
import { useSelector } from 'react-redux';
import { isEditMode } from 'services/admin';
import { getDefaultNavigation } from 'services/navigationv2';
import { getPagePath } from 'shared/page-utils';

interface GoToPageProps extends PropsWithChildren {
  pageId: string;
}

const GoToPage: React.FC<GoToPageProps> = ({ children, pageId }) => {
  const isEditing = useSelector(isEditMode);
  const siteStructure = useSelector(getDefaultNavigation);
  const pagePath = getPagePath(siteStructure, pageId);

  if (isEditing || !pagePath) {
    return <React.Fragment>{children}</React.Fragment>;
  }

  return (
    <ObjectLink collection="pages" slug={pagePath}>
      {children}
    </ObjectLink>
  );
};

export default GoToPage;
